import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const workOrderApi = createApi({
  reducerPath: 'workOrderApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['WorkOrder'],
  endpoints: (builder) => ({
    getWorkOrders: builder.query<unknown[], { status?: string; productionLineId?: string } | void>({
      query: (params) => ({
        url: 'work-orders',
        params: params || {},
      }),
      providesTags: ['WorkOrder'],
    }),
    getWorkOrder: builder.query<unknown, string>({
      query: (id) => `work-orders/${id}`,
      providesTags: ['WorkOrder'],
    }),
    getWorkOrdersByOrder: builder.query<unknown[], string>({
      query: (orderId) => `work-orders/by-order/${orderId}`,
      providesTags: ['WorkOrder'],
    }),
    updateWorkOrder: builder.mutation<unknown, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `work-orders/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['WorkOrder'],
    }),
    deleteWorkOrder: builder.mutation<void, string>({
      query: (id) => ({ url: `work-orders/${id}`, method: 'DELETE' }),
      invalidatesTags: ['WorkOrder'],
    }),
  }),
});

export const {
  useGetWorkOrdersQuery,
  useGetWorkOrderQuery,
  useGetWorkOrdersByOrderQuery,
  useUpdateWorkOrderMutation,
  useDeleteWorkOrderMutation,
} = workOrderApi;
